import ReadSettings from "./ReadSettings";

export default ReadSettings;